import { computed } from 'vue'
import { useStore } from 'vuex'

import privilegeService from '@/services/privilege.service'

export const hasFullSettingsAccess = () =>
  privilegeService.isMerchant() ||
  privilegeService.isDefaultMerchantUser() ||
  (privilegeService.getSystemUserId() && privilegeService.isAdmin())

export const userCapabilities = user => user?.attributes?.capabilities ?? []

export function useSettingsAccess() {
  const store = useStore()

  const user = computed(() => store.state.loggedInUser)
  const isMerchant = computed(() => privilegeService.isMerchant())
  const isDefaultMerchantUser = computed(() => privilegeService.isDefaultMerchantUser())
  const isAdmin = computed(() => privilegeService.isAdmin())
  const systemUserId = computed(() => privilegeService.getSystemUserId())
  const systemUserEmail = computed(() => privilegeService.getSystemUserEmail())

  const hasFullAccess = computed(hasFullSettingsAccess)
  const canEditEmails = computed(() => isMerchant.value || (systemUserId.value && isAdmin.value))
  const canManageUsers = computed(() => privilegeService.canAccessRoute('/users/roles'))
  const capabilities = computed(() => userCapabilities(user.value))
  const isCatering = computed(() => Boolean(store.getters.isCatering))
  const currentUserEmail = computed(() => systemUserEmail.value || user.value?.attributes?.email || '')

  return {
    user,
    isMerchant,
    isDefaultMerchantUser,
    isAdmin,
    systemUserId,
    systemUserEmail,
    hasFullAccess,
    canEditEmails,
    canManageUsers,
    capabilities,
    isCatering,
    currentUserEmail
  }
}
